import React from 'react';

function Footer() {
  return (
    <footer className="bg-white border-t border-primary-200 mt-10">
      <div className="max-w-6xl mx-auto px-4 py-4 text-sm text-primary-800">
        © {new Date().getFullYear()} Focus Garden
      </div>
    </footer>
  );
}

export default Footer;
